import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { Button } from './Button';
import { isMobile } from '../../../utils/commonMethods';
import { globalFontStyle } from '../../../assets/Font/FontFamily';

export const TradingButtons = ({
  yesPrice,
  noPrice,
  onPress,
  disabled,
  isEvent = false,
  style,
  yesStyle,
  noStyle,
  className = '',
}) => {
  const handlePress = (e, isYes) => {
    if (disabled) return;
    
    // Create synthetic event if none provided
    const event = e || {
      preventDefault: () => {},
      stopPropagation: () => {},
    };

    if (isEvent) {
      setTimeout(() => {
        onPress(event, isYes);
      }, 300); // Add delay for event buttons
    } else {
      onPress(event, isYes);
    }
  };

  const renderButtonContent = (text, price) => (
    <View style={styles.buttonContent}>
      <Text style={[globalFontStyle.appFontMedium, styles.buttonText]}>
        {text}
      </Text>
      <Text style={[globalFontStyle.appFontMedium, styles.buttonText]}>
        {price}
      </Text>
    </View>
  );

  return (
    <View style={[styles.container, style]}>
      <Button
        variant="yes"
        size="default"
        onPress={(e) => handlePress(e, true)}
        disabled={disabled}
        style={[styles.button, yesStyle]}
        className={`card-button ${className} ${disabled ? 'button-disabled' : ''}`}
      >
        {renderButtonContent('Yes', yesPrice)}
      </Button>
      <View style={styles.gap} />
      <Button
        variant="no"
        size="default"
        onPress={(e) => handlePress(e, false)}
        disabled={disabled}
        style={[styles.button, noStyle]}
        className={`card-button ${className} ${disabled ? 'button-disabled' : ''}`}
      >
        {renderButtonContent('No', noPrice)}
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flex: 1,
  },
  button: {
    flex: 1,
    minHeight: isMobile() ? 36 : 40,
  },
  gap: {
    width: 8,
  },
  buttonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  buttonText: {
    textAlign: 'center',
  },
}); 